import React from "react";
import {
  checkRadioNotSelected,
  checkRadioSelected,
  crossRadioNotSelected,
  crossRadioSelected,
  infoIcn,
} from "../images/btnIcons";
import { isNewUI } from "./handleProgress";
import { allowedOtpKeys } from "./allowedOtpKeys";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Checkbox } from "@material-ui/core";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CustomMultiselect from "../components/FormComponents/CustomMultiselect/CustomMultiselect";
import CustomDatePicker from "../components/FormComponents/CustomDatePicker/CustomDatePicker";
import { handleDropdownOptionForEngLang } from "./handleData";

const handleChange = (e, question, type, termPlan, termPlanLogic) => {
  let value =
    type === "checkbox" || type === "checkbox2" || type === "checkbox5"
      ? e.target.checked
      : e;
  let checkbox5QstId = "";
  if (type === "checkbox" || type === "checkbox2" || type === "checkbox5") {
    value === true ? (value = "Yes") : (value = "No");
    checkbox5QstId = e.target.name;
  }

  if (question.qstOptType === "number5" && value.length > question?.maxLength) {
    return;
  }

  if (
    (type === "number" && value.length === 1 && value === "0") ||
    (type === "number" && isNaN(Number(value)))
  ) {
    value = value.slice(0, -1);
  }
  if (type === "text3") {
    console.log(value);
    let val = value.replace(/[^0-9]/g, "");
    console.log("val", val);
    value = val;
  }
  const { qstId, qstType, qstOptType, qstPrtId, mandatory, qstOpt } = question;
  var event = new CustomEvent("emitted", {
    detail: {
      qstId,
      qstType,
      qstOptType,
      qstPrtId,
      value,
      termPlan,
      mandatory,
      qstOpt,
      checkbox5QstId,
      termPlanLogic,
    },
  });
  document.dispatchEvent(event);
};

export const getQstOptions = (qstOpts) => {
  if(isNewUI()) {
    return qstOpts
  } else {
    return ["Yes", "No"]
  }
}

export default function createInput(field) {
  let {
    qstOptType,
    qstText,
    qstId,
    qstOpt,
    customerResponse,
    mandatory,
    maxLength,
    // qstFreezeResponse,
    userType,
  } = field.question;

  let { getParentQuestionResponse, handleDrawerDisplay, handleUserAnswer } = field;

  if (qstOptType === "checkbox5") {
    // console.log('first', getParentQuestionResponse(field.question.qstPrtId))
  }

  if (userType != undefined) {
    const userTypeSplit = userType.split("^^^");
    const mandatoryStar = () => {
      return (
        <>{mandatory === "M" ? <span className="required"> *</span> : null}</>
      );
    };
    var userTypeSplitted = userTypeSplit.map((q, i) => {
      return (
        <p key={i}>
          {`${q}`}
          {mandatoryStar()}
        </p>
      );
    });
  }

  const qst = qstText.split("^^^");
  const mandatoryStar = () => {
    return (
      <>
        {mandatory === "M" ? (
          <span
            className={`required ${
              qstOptType === "dropdown5"
                ? "ssp_dropdown_span"
                : qstOptType === "number5"
                ? "ssp_num_span"
                : ""
            }`}
          >
            {" "}
            *
          </span>
        ) : null}
      </>
    );
  };

  const getRadioBtnClassForNewUi = (optionIndex) => {
    if (isNewUI()) {
      return `new-ui-radio-btn ${
        optionIndex == 0 ? "new-ui-radio-btn-left-float" : ""
      }`;
    } else {
      return "";
    }
  };

  const getNewUIQuesText = () => {
    const quesTxt = qstText.split("^^^");
    let quesHeading = quesTxt[0];
    let quesLabels = quesTxt.slice(1);
    return (
      <>
        <label
          className={
            quesTxt.length > 1
              ? "posv2-new-ques-heading manipuri-font"
              : "posv2-new-ques-heading dark-heading manipuri-font"
          }
        >
          {quesHeading}
        </label>
        {/* {(qstId == "COM1" || qstId == "COM2") && (
          <span className="info-icn-cntnr">
            <img
              onClick={handleDrawerDisplay}
              className="info_icn"
              src={infoIcn}
              alt="info_icn"
            />
          </span>
        )} */}
        {quesLabels &&
          quesLabels.length > 0 &&
          quesLabels.map((qL, i) => (
            <p
              className={
                qstId === "PREM"
                  ? "posv2-new-ques-txt manipuri-font new-ques-note"
                  : "posv2-new-ques-txt manipuri-font"
              }
              key={i}
            >
              {/* {qL} */}
              {getNewQuesUISubquesSpan(qL, i)}
            </p>
          ))}
      </>
    );
  };

  const getNewQuesUISubquesSpan = (text, subQuesIndex) => {
    let splittedText = text.split(":");
    if (splittedText.length > 1) {
      return (
        <>
          {localStorage.getItem("LanguageSelected") === "Assamese" ? (
            <span>{splittedText[0]}:</span>
          ) : (
            <span>{splittedText[0]} : </span>
          )}
          <span
            className={
              splittedText[0].trim().toLowerCase() === "non - guaranteed"
                ? "light-wt-txt"
                : ""
            }
          >
            {splittedText[1]}
            {localStorage.getItem("LanguageSelected") === "Assamese"
              ? splittedText[2]
              : null}
          </span>
        </>
      );
    } else {
      return splittedText[0];
    }
  };

  const getNameForCheckbox5 = () => {
    let insurerQuesName, proposerQuesName;
    if (userType === "Proposer") {
      insurerQuesName = `${field.question.originalQstId}-Insurer`;
      proposerQuesName = `${field.question.originalQstId}-Proposer`;
    } else {
      insurerQuesName = `${field.question.qstId.split("-")[0]}-Insurer`;
      proposerQuesName = `${field.question.qstId.split("-")[0]}-Proposer`;
    }

    return { insurerQuesName, proposerQuesName };
  };

  const getQuestions = qst.map((q, i) => {
    if (field.type == "radio2" && field.question.hindiText) {
      return (
        <>
          {i == 0 && (
            <p key={i}>
              {`${q}`}
              {mandatoryStar()}
            </p>
          )}
          {i == 1 && (
            <p key={i}>
              {`${field.question.hindiText}`}
              {mandatoryStar()}
            </p>
          )}
        </>
      );
    }

    if (["text", "text2", "text3", "text5"].includes(field.question.qstOptType) && isNewUI()) {
      return (
        <p key={i}>
          {`${q}`}
          {mandatoryStar()}
        </p>
      )
    }
    return (
      <p key={i}>
        {`${q}`}
        {q!=="Or"&&mandatoryStar()}
      </p>
    );

  });

  const handleKeyDown = (e) => {
    // console.log("key code : ",e.keyCode,allowedOtpKeys.includes(e.keyCode))
    if (qstOptType === "number5") {
      if (!allowedOtpKeys.includes(e.keyCode)) e.preventDefault();
    }
  };

  const getRadio2LabelsForNewUI = () => {
    const quesTxt = qstText.split("^^^");
    if (quesTxt.length > 1) {
      return [
        <p className="manipuri-font">
          {`${quesTxt[0]}`}
          {mandatoryStar()}
        </p>,
        <>
          {isNewUI() ? (
            <p
              className={
                localStorage.getItem("LanguageSelected") === "Manipuri"
                  ? "manipuri-font-note"
                  : "ques-note"
              }
            >
              {`${quesTxt[1]}`}
            </p>
          ) : (
            ""
          )}
        </>,
      ];
    } else {
      return [
        <p className={localStorage.getItem("LanguageSelected") === "Manipuri" ? "manipuri-font" : ""}>
          {`${qstText}`}
          {mandatoryStar()}
        </p>,
      ];
    }
  };

  switch (qstOptType) {
    case "text3":
    case "text5":
      return (
        <fieldset style={{ display: field.question.display }}>
          {/* <label>{getQuestions}</label> <br /> */}
          {/* {qstOptType === 'text5' && <p className="ssp_user_type" >{userTypeSplitted}</p>} */}
          <input
            type="text"
            name={qstId}
            style={{ marginTop: "16px" }}
            maxLength={maxLength}
            value={customerResponse}
            placeholder={
              qstText.split("^^^").length
                ? qstText.split("^^^").join(" / ")
                : qstText
            }
            required
            onChange={(event) =>
              handleChange(event.target.value, field.question, qstOptType)
            }
          />
          {mandatoryStar()}
        </fieldset>
      );
    case "text2":
      return (
        <fieldset style={{ display: field.question.display }}>
          <label>{getQuestions}</label> <br />
          <input
            type="text"
            name={qstId}
            style={{ marginTop: "16px" }}
            maxLength={75}
            value={customerResponse}
            required
            onChange={(event) =>
              handleChange(event.target.value, field.question, qstOptType)
            }
          />
          {mandatoryStar()}
        </fieldset>
      );
    case "radio":
      return (
        <fieldset style={{ display: field.question.display }}>
          {!field.isWopRider ||
          field.isWopRider === "N" ||
          field.question.userType === field.primaryUserType ||
          (field.question.userType === field.secondaryUserType &&
            (field.question.qstType === "Secondary" || field.question.qstType === "Tertiary")) ||
          field.question.qstType === "Parent"
            ? getQuestions
            : null}
          {field.isWopRider === "Y" &&
          field.question.qstType !== "Secondary" ? (
            <p>{userTypeSplitted}</p>
          ) : null}
          {field.isWopRider === "Y" &&
          field.question.qstType === "Secondary" &&
          field.question.userType !== "Insurer" &&
          field.question.userType !== "Proposer" ? (
            <p>{getQuestions}</p>
          ) : null}
          <input
            type="radio"
            name={qstId}
            value={getQstOptions(qstOpt)[0]}
            id={`${qstId}-Yes`}
            disabled={field.question.qstFreezeResponse === getQstOptions(qstOpt)[1]}
            required
            checked={
              (field.question.customerResponse === getQstOptions(qstOpt)[0] ? true : false) ||
              field.question.qstFreezeResponse === getQstOptions(qstOpt)[0]
            }
            onChange={(event) =>
              handleUserAnswer ? handleUserAnswer(event, field.question):
              handleChange(
                event.target.value,
                field.question,
                qstOptType,
                field.termPlan,
                field.termPlanLogic
              )
            }
          />{" "}
          <label
            className={getRadioBtnClassForNewUi(0)}
            htmlFor={`${qstId}-Yes`}
          >
            {qstOpt[0]}
          </label>
          <input
            type="radio"
            name={qstId}
            value={getQstOptions(qstOpt)[1]}
            id={`${qstId}-No`}
            disabled={field.question.qstFreezeResponse === getQstOptions(qstOpt)[0]}
            checked={
              field.question.customerResponse === getQstOptions(qstOpt)[1]
                ? true
                : false || field.question.qstFreezeResponse === getQstOptions(qstOpt)[1]
            }
            onChange={(event) =>
              handleUserAnswer ? handleUserAnswer(event, field.question):
              handleChange(
                event.target.value,
                field.question,
                qstOptType,
                field.termPlan,
                field.termPlanLogic
              )
            }
          />{" "}
          <label
            className={getRadioBtnClassForNewUi(1)}
            htmlFor={`${qstId}-No`}
          >
            {qstOpt[1]}
          </label>
        </fieldset>
      );
    case "text2":
    case "text":
      let textFieldProps = {}
      if(field.question.qstDiseaseType){
        textFieldProps.placeholder = "Enter Details"
      }else{
        textFieldProps.label = getQuestions
      }
      return (
        <fieldset style={{ display: field.question.display }}>
          {
            isNewUI() ? (
              <>
                {field.question.qstDiseaseType&&<label className="new-ui-txt-field-label">{getQuestions}</label> }
                <TextField
                  className="new-ui-txt-field"
                  autoComplete="off"
                  variant="outlined"
                  fullWidth
                  type="text"
                  label={!field.question.qstDiseaseType?getQuestions:null}
                  placeholder={field.question.qstDiseaseType?"Enter Details":""}
                  // {...textFieldProps}
                  name={qstId}
                  style={{ marginTop: "16px" }}
                  maxLength={75}
                  value={customerResponse}
                  // inputProps={
                  //   ...textFieldProps
                  // }
                  // required
                  onChange={(event) =>
                    handleChange(event.target.value, field.question, qstOptType)
                  }
                />
              </>
            ) : (
              <>
                <label>{getQuestions}</label> <br />
                <input
                  type="text"
                  name={qstId}
                  style={{ marginTop: "16px" }}
                  maxLength={75}
                  value={customerResponse}
                  required
                  onChange={(event) =>
                    handleChange(event.target.value, field.question, qstOptType)
                  }
                />
                {mandatoryStar()}
              </>
            )
          }
        </fieldset>
      );
    case "tel":
    case "number":
    case "number5":
      const pattern = qstOptType === "number" ? "/^[1-9]d*$/g" : "";

      return (
        <fieldset style={{ display: field.question.display }}>
          {
            isNewUI() ? (
              <>
                {qstOptType === "number5" && (
                  <p className="ssp_user_type">{userTypeSplitted}</p>
                )}
                <TextField
                  className="new-ui-txt-field num-mui-inpt"
                  variant="outlined"
                  name={qstId}
                  type="number"
                  placeholder={
                    qstText.split("^^^").length
                      ? qstText.split("^^^").join(" / ")
                      : qstText
                  }
                  // label={
                  //   qstText.split("^^^").length
                  //     ? qstText.split("^^^").join(" / ")
                  //     : qstText
                  // }
                  fullWidth
                  value={customerResponse}
                  required
                  onKeyDown={handleKeyDown}
                  onChange={(event) =>
                    handleChange(event.target.value, field.question, qstOptType)
                  }
                />
              </>
            ) : (
              <>
                {qstOptType === "number5" && (
                  <p className="ssp_user_type">{userTypeSplitted}</p>
                )}
                <input
                  type={qstOptType === "number5" ? "number" : qstOptType}
                  name={qstId}
                  pattern={pattern}
                  style={{ marginTop: "16px" }}
                  placeholder={
                    qstText.split("^^^").length
                      ? qstText.split("^^^").join(" / ")
                      : qstText
                  }
                  value={customerResponse}
                  required
                  onKeyDown={handleKeyDown}
                  onChange={(event) =>
                    handleChange(event.target.value, field.question, qstOptType)
                  }
                />
                {mandatoryStar()}
              </>
            )
          }
{/* 
          {qstOptType === "number5" && (
            <p className="ssp_user_type">{userTypeSplitted}</p>
          )}
          <input
            type={qstOptType === "number5" ? "number" : qstOptType}
            name={qstId}
            pattern={pattern}
            style={{ marginTop: "16px" }}
            placeholder={
              qstText.split("^^^").length
                ? qstText.split("^^^").join(" / ")
                : qstText
            }
            value={customerResponse}
            required
            onKeyDown={handleKeyDown}
            onChange={(event) =>
              handleChange(event.target.value, field.question, qstOptType)
            }
          />
          {mandatoryStar()} */}
        </fieldset>
      );

    case "radio2":
      return (
        <fieldset style={{ display: field.question.display }}>
          {!field.isWopRider ||
          field.isWopRider === "N" ||
          field.question.userType === field.primaryUserType ||
          (field.question.userType === field.secondaryUserType &&
            field.question.qstType === "Secondary") ||
          (!field.termPlan && field.question.qstType === "Parent")
            ? isNewUI()
              ? getRadio2LabelsForNewUI()[0]
              : getQuestions
            : null}
          {qstOpt.map((opt, i) => (
            <>
              <input
                key={i + qstId}
                type="radio"
                name={qstId}
                value={
                  opt === "None of these/ इनमें से कोई नहीं"
                    ? "None of these"
                    : opt
                }
                id={`${qstId}-${opt}`}
                // disabled={field.question.qstFreezeResponse === "Yes"}
                checked={
                  field.question.customerResponse ==
                  (opt === "None of these/ इनमें से कोई नहीं"
                    ? "None of these"
                    : opt)
                    ? true
                    : false
                }
                onChange={(event) =>
                  handleUserAnswer ? handleUserAnswer(event, field.question):
                  handleChange(
                    event.target.value,
                    field.question,
                    qstOptType,
                    field.termPlan
                  )
                }
              />
              <label
                className={`${getRadioBtnClassForNewUi(
                  i
                )} radio2-label manipuri-font`}
                htmlFor={`${qstId}-${opt}`}
                key={i}
              >
                {opt}
              </label>
            </>
          ))}

          {getRadio2LabelsForNewUI()[1] && getRadio2LabelsForNewUI()[1]}
        </fieldset>
      );
    case "radio5":
      return (
        <fieldset
          className="radio-5"
          style={{ display: field.question.display }}
        >
          <div className="radio-5-cntnr">
            {!field.isWopRider ||
            field.isWopRider === "N" ||
            field.question.userType === field.primaryUserType ||
            (field.question.userType === field.secondaryUserType &&
              field.question.qstType === "Secondary") ||
            (!field.termPlan && field.question.qstType === "Parent") ? (
              <div className="main-ques-radio-5">{getQuestions}</div>
            ) : null}
            {field.isWopRider === "Y" &&
            field.question.qstType !== "Secondary" ? (
              <div
                className={
                  userType === "Proposer"
                    ? "sub-ques-radio-5 proposer"
                    : "sub-ques-radio-5 insurer"
                }
              >
                <p className="userType">{userTypeSplitted}</p>
                <input
                  type="radio"
                  name={qstId}
                  value={getQstOptions(qstOpt)[0]}
                  id={`${qstId}-Yes`}
                  disabled={field.question.qstFreezeResponse === getQstOptions(qstOpt)[1]}
                  required
                  checked={
                    (field.question.customerResponse === getQstOptions(qstOpt)[0]
                      ? true
                      : false) || field.question.qstFreezeResponse === getQstOptions(qstOpt)[0]
                  }
                  onChange={(event) =>
                    handleChange(
                      event.target.value,
                      field.question,
                      qstOptType,
                      field.termPlan
                    )
                  }
                />{" "}
                <label htmlFor={`${qstId}-Yes`}>{qstOpt[0]}</label>
                <input
                  type="radio"
                  name={qstId}
                  value={getQstOptions(qstOpt)[1]}
                  id={`${qstId}-No`}
                  disabled={field.question.qstFreezeResponse === getQstOptions(qstOpt)[0]}
                  checked={
                    field.question.customerResponse === getQstOptions(qstOpt)[1]
                      ? true
                      : false || field.question.qstFreezeResponse === getQstOptions(qstOpt)[1]
                  }
                  onChange={(event) =>
                    handleChange(
                      event.target.value,
                      field.question,
                      qstOptType,
                      field.termPlan
                    )
                  }
                />{" "}
                <label htmlFor={`${qstId}-No`}>{qstOpt[1]}</label>
              </div>
            ) : null}
          </div>
        </fieldset>
      );
    case "radio4":
      return (
        <fieldset
          style={{ display: field.question.display }}
          className="proposal-fieldset"
        >
          {!field.isWopRider ||
          field.isWopRider === "N" ||
          field.question.userType === field.primaryUserType ||
          (field.question.userType === field.secondaryUserType &&
            field.question.qstType === "Secondary") ||
          (!field.termPlan && field.question.qstType === "Parent") ? (
            <div className="rowCustom">
              <div className="colCustom qst-txt-cntnr">
                {/* {getQuestions} */}
                {getNewUIQuesText()}
              </div>
              <div className="colCustom1">
                <ul className="radioCircle">
                  {qstOpt.map((opt, i) => (
                    <li
                      className={i === 1 ? "noRadio" : "yesRadio"}
                      key={i + qstId}
                    >
                      <input
                        onChange={(event) =>
                          handleChange(
                            event.target.value,
                            field.question,
                            qstOptType,
                            field.termPlan
                          )
                        }
                        value={opt}
                        checked={
                          field.question.customerResponse == opt ? true : false
                        }
                        type="radio"
                        className="cstm-radio4"
                        name={qstId}
                        id={`${qstId}-${opt}`}
                      />
                      <label
                        className="cstm-radio4-label"
                        htmlFor={`${qstId}-${opt}`}
                      >
                        {i === 0 ? (
                          <img
                            src={
                              field.question.customerResponse == opt
                                ? checkRadioSelected
                                : checkRadioNotSelected
                            }
                          />
                        ) : (
                          <img
                            src={
                              field.question.customerResponse == opt
                                ? crossRadioSelected
                                : crossRadioNotSelected
                            }
                          />
                        )}
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ) : null}
        </fieldset>
      );

    case "dropdown":
    case "dropdown5":
      const selectedValue = customerResponse ? customerResponse : "default";
      return (
        <fieldset style={{ display: field.question.display }}>
          {
            isNewUI() ? (
              <>
                <FormControl variant="outlined" className="new-ui-dropdown" fullWidth >
                  <InputLabel id="new-ui-select-label">{qstText}</InputLabel>
                  <Select
                    // native
                    labelId="new-ui-select-label"
                    id="new-ui-select"
                    label={qstText}
                    value={selectedValue === 'default' ? "" : selectedValue}
                    onChange={(event) =>
                      handleChange(event.target.value, field.question)
                    }
                  >
                    <MenuItem value="default" disabled>
                      {qstText}
                    </MenuItem>
                    {/* <option aria-label="None" value="" /> */}
                    {qstOpt.map((el, i) => {
                      return (
                        <MenuItem
                          key={i}
                          value={
                            handleDropdownOptionForEngLang(qstOpt[i])
                          }
                          className="new-ui-dropdown-item"
                        >
                          {qstOpt[i]}
                        </MenuItem>
                      );
                    })
                    }

                  </Select>
                </FormControl>
              </>
            ) : (
              <>
                <select
                  name={qstId}
                  style={{ marginTop: "16px", minWidth: "auto" }}
                  value={selectedValue}
                  className={qstOptType === "dropdown5" ? "ssp_dropdown" : ""}
                  onChange={(event) =>
                    handleChange(event.target.value, field.question)
                  }
                >
                  <option value="default" disabled hidden>
                    {qstText}
                  </option>
                  {qstOpt.map((el, i) => {
                    return (
                      <option
                        key={i}
                        value={
                          handleDropdownOptionForEngLang(qstOpt[i])
                        }
                      >
                        {qstOpt[i]}
                      </option>
                    );
                  })}
                </select>
                {mandatoryStar()}
              </>
            )
          }

        </fieldset>
      );

    case "checkbox3":
      return (
        <div className="new_checkbox checkbox3">
          <label htmlFor={qstId} className="generateotp-checkobox">
            <input
              type="checkbox"
              name={qstId}
              className="regular-checkbox manipuri-font"
              value={customerResponse}
              checked={customerResponse === qstOpt[0] ? true : false}
              onChange={(event) =>
                handleChange(event, field.question, "checkbox2")
              }
              id={qstId}
            />
            <span className="checkmark"></span>
          </label>
          <p className="check-sec manipuri-font">{getQuestions}</p>
        </div>
      );

    case "checkbox2":
      customerResponse = !customerResponse ? "No" : customerResponse;
      return (
        <fieldset style={{ display: field.question.display }}>
          <p className="check-sec">{getQuestions}</p>
          <input
            type="checkbox"
            name={qstId}
            className="regular-checkbox manipuri-font"
            value={customerResponse}
            checked={customerResponse === qstOpt[0] ? true : false}
            onChange={(event) =>
              handleChange(event, field.question, "checkbox2")
            }
          />
          {mandatoryStar()}
        </fieldset>
      );
    case "checkbox":
      customerResponse = !customerResponse ? "No" : customerResponse;
      return (
        <fieldset style={{ display: field.question.display }}>
          {
            isNewUI() ? (
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    className="regular-checkbox manipuri-font"
                    value={customerResponse}
                    checked={customerResponse === "Yes" ? true : false}
                    onChange={(event) =>
                      handleChange(event, field.question, "checkbox")
                    }
                  />
                }
                label={getQuestions}
              />
            ) : (
              <>
                <p className="check-sec">{getQuestions}</p>
                <input
                  type="checkbox"
                  name={qstId}
                  className="regular-checkbox manipuri-font"
                  value={customerResponse}
                  checked={customerResponse === "Yes" ? true : false}
                  onChange={(event) =>
                    handleChange(event, field.question, "checkbox")
                  }
                />
                {mandatoryStar()}
              </>
            )
          }
        </fieldset>
      );
    case "checkbox5":
      customerResponse = !customerResponse ? "No" : customerResponse;
      return (
        <fieldset style={{ display: field.question.display }}>
          {userType === "Proposer" ? (
            <div className={"checbox-5-headings " + qstId}>
              <p className="multiselect-txt">Multiple Select Options</p>
              <div>
                <p className="multiselect-pro">Proposer</p>
                <p className="multiselect-ins">Insurer</p>
              </div>
            </div>
          ) : getParentQuestionResponse(
              `${field.question.qstPrtId.split("-")[0]}-Proposer`
            )?.customerResponse == "No" &&
            getParentQuestionResponse(
              `${field.question.qstPrtId.split("-")[0]}-Insurer`
            )?.customerResponse == "Yes" ? (
            <div className={"checbox-5-headings " + qstId}>
              <p className="multiselect-txt">Multiple Select Options</p>
              <div>
                <p className="multiselect-pro">Proposer</p>
                <p className="multiselect-ins">Insurer</p>
              </div>
            </div>
          ) : null}
          {/* <div className="checbox-5-headings" >
            <p className="multiselect-txt" >Multiple Select Options</p>
            <div>
              <p className="multiselect-pro">Proposer</p>
              <p className="multiselect-ins">Insurer</p>
            </div>
          </div> */}
          <div
            className={
              userType === "Proposer"
                ? "checkbox-5-cntnr proposer"
                : getParentQuestionResponse(
                    `${field.question.qstPrtId.split("-")[0]}-Proposer`
                  )?.customerResponse == "No" &&
                  getParentQuestionResponse(
                    `${field.question.qstPrtId.split("-")[0]}-Insurer`
                  )?.customerResponse == "Yes"
                ? "checkbox-5-cntnr proposer"
                : "checkbox-5-cntnr insurer"
            }
          >
            {/* <div className={userType === "Proposer" ? "checkbox-5-cntnr proposer" : "checkbox-5-cntnr insurer"} > */}
            <p
              className={
                userType === "Proposer"
                  ? "check-sec proposer"
                  : "check-sec insurer"
              }
            >
              {getQuestions}
            </p>
            {/* {mandatoryStar()} */}
            <div className="checkbox-5-opts-cntnr">
              <input
                type="checkbox"
                name={getNameForCheckbox5().proposerQuesName}
                // name={`${field.question.originalQstId}-Proposer`
                value={customerResponse}
                className="proposer-checkbox"
                checked={
                  getParentQuestionResponse(
                    getNameForCheckbox5().proposerQuesName
                  )?.customerResponse === "Yes"
                    ? true
                    : false
                }
                // checked={getParentQuestionResponse(`${field.question.originalQstId}-Proposer`)?.customerResponse === qstOpt[0] ? true : false}
                onChange={(event) =>
                  handleChange(event, field.question, "checkbox5")
                }
              />
              <input
                type="checkbox"
                name={getNameForCheckbox5().insurerQuesName}
                // name={`${field.question.originalQstId}-Insurer`}
                value={customerResponse}
                className="insurer-checkbox"
                checked={
                  getParentQuestionResponse(
                    getNameForCheckbox5().insurerQuesName
                  )?.customerResponse === "Yes"
                    ? true
                    : false
                }
                // checked={getParentQuestionResponse(`${field.question.originalQstId}-Insurer`)?.customerResponse === qstOpt[0] ? true : false}
                onChange={(event) =>
                  handleChange(event, field.question, "checkbox5")
                }
              />
            </div>
          </div>
        </fieldset>
      );
    case "textarea":
      return (
        <fieldset
          style={{ display: field.question.display }}
          onChange={(event) => handleChange(event.target.value, field.question)}
        >
          <p>
            {getQuestions}
            <span className="required"> *</span>
          </p>
          <textarea rows={5} cols={30}></textarea>
        </fieldset>
      );
    // case "dateYearMask":
    //   return (
    //     <fieldset style={{ display: field.question.display }}>
    //       <MaskedInput
    //         style={{ marginTop: "16px" }}
    //         mask="11/1111"
    //         name={qstId}
    //         id={qstId}
    //         value={customerResponse}
    //         placeholder={qstText}
    //         onChange={(event) =>
    //           handleChange(event.target.value, field.question, "dateYearMask")
    //         }
    //       />
    //       {mandatoryStar()}
    //     </fieldset>
    //   );

    case "calender":
      let calenderValue = customerResponse ? customerResponse : new Date();
      return (
        <fieldset style={{ display: field.question.display }}>
          <label>{getQuestions}</label>
          <input
            type="date"
            name={qstId}
            value={calenderValue}
            placeholder={qstText}
            onChange={(event) =>
              handleChange(event.target.value, field.question, "calender")
            }
          />
          {!isNewUI()?mandatoryStar():null}
        </fieldset>
      );
    case "calender2":
      return (
        <fieldset style={{ display: field.question.display }}>
          <CustomDatePicker customerResponse={customerResponse} question={field.question} label={getQuestions} updateResponse={handleChange} />
        </fieldset>
      )
    case "multipleSelection":
      return (
        <fieldset style={{ display: field.question.display }} className="cstm-multi-selct">
          <CustomMultiselect customerResponse={customerResponse} question={field.question} label={getQuestions} updateResponse={handleChange} />
        </fieldset>
      )
    default:
      return null;
  }
}
